import { getIssuePriority } from 'pages/Desk/issues/shared';
import { Lozenge } from 'shared/lozenge/Lozenge';

type PriorityLozengeProps = Readonly<{
    priority: number;
}>;

export function PriorityLozenge({ priority }: PriorityLozengeProps) {
    const { label, backgroundColor, textColor } = getIssuePriority(priority);
    const upperLabel = label.toUpperCase();

    return (
        <Lozenge color={textColor} backgroundColor={backgroundColor}>
            {upperLabel}
        </Lozenge>
    );
}
